module.exports = __webpack_public_path__ + "static/media/arrowRight.ede82d2b.svg";